import React from "react";
import PropTypes from "prop-types";
import s from "./Textarea.module.css";

const Textarea = ({
  label, // Метка для поля textarea
  placeholder = "", // Placeholder для поля textarea
  value, // Значение поля
  onChange, // Обработчик изменения значения
  style, // Дополнительные стили
  disabled = false, // Состояние блокировки поля
  error, // Ошибка для валидации
  bolder,
  rows = 4, // Количество строк по умолчанию
  icon, // Иконка, если нужна
  ...rest
}) => {
  return (
    <div
      className={s.customtextarea}
      style={style}
    >
      {label && <label className={s.customtextarealabel}>{label}</label>}
      <div className={s.customtextareawrapper}>
        <textarea
          className={`${s.customtextareafield} ${
            error ? s.customtextareaerror : ""
          } ${bolder ? s.customtextareabolder : ""}`}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          rows={rows}
          {...rest}
        />
        {icon && <span className={s.customtextareaicon}>{icon}</span>}
      </div>
      {error && <span className={s.customtextareaerrormessage}>{error}</span>}
    </div>
  );
};

Textarea.propTypes = {
  label: PropTypes.string, // Метка поля textarea
  placeholder: PropTypes.string, // Placeholder для поля
  value: PropTypes.string, // Значение поля
  onChange: PropTypes.func.isRequired, // Обработчик изменения значения
  style: PropTypes.object, // Дополнительные стили
  disabled: PropTypes.bool, // Состояние блокировки
  error: PropTypes.string, // Ошибка (для валидации)
  bolder: PropTypes.bool,
  rows: PropTypes.number, // Количество строк
  icon: PropTypes.node, // Иконка (Reactкомпонент или строка)
};

// Textarea.defaultProps = {
//   placeholder: "",
//   value: "",
//   style: {},
//   disabled: false,
//   error: "",
//   bolder: false,
//   rows: 4,
//   icon: null,
// };

export default Textarea;
